export * from './breadcrumb';

import { BreadcrumbComponent } from './breadcrumb';

export const BreadcrumbOrganisms = [
    BreadcrumbComponent
];